module.exports = __webpack_public_path__ + "static/media/icon_bag.f6ba1db2.svg";